import React from "react";
import { TextEditor } from "../../../../../components/TextEditor";
import { ElementWrapper } from "../../../components/ElementWrapper";
import { HeaderSelectWrapper } from "../../../components/HeaderSelectWrapper";
import { TextAreaEdit } from "../../../components/TextAreaEdit";
import { IElement } from "../../../models/Element";
import { TableFiveColumns } from "./TableFiveColumns";
import { TableFiveColumnsTable } from "./TableFiveColumnsTable";

interface Props {
  index: number;
  data: TableFiveColumns;
  updateData: (body: IElement, index: number) => void;
}

export const TableFiveColumnsFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (to: Partial<TableFiveColumns>) => {
    const updatedData = { ...data, ...to };
    updateData(updatedData, index);
  };
  return (
    <ElementWrapper elementIndex={index}>
      <div className="table-two-columns">
        <HeaderSelectWrapper
          name={"header_type"}
          value={data.header_type}
          setValue={update}
        >
          <TextAreaEdit
            className="heading"
            name={"header"}
            value={data.header}
            setValue={update}
          />
        </HeaderSelectWrapper>

        <TableFiveColumnsTable data={data} update={update} />

        <div className="content">
          <TextEditor
            content={data.content}
            updateContent={(content) => update({ content })}
          />
        </div>
      </div>
    </ElementWrapper>
  );
};
